import axios, { AxiosRequestConfig } from "axios";
import RequestAPI from "../..";
import StorageItems from "../../../storage";
import { generateMessageReturn } from "../../../utils/messageFuncs";

const auth = new StorageItems().get("authToken");

class ApiFornecedores extends RequestAPI {
  config: AxiosRequestConfig;
  data?: any;
  token;
  basePath = "fornecedores";
  constructor(data?: any) {
    super();
    this.token = auth?.authToken;

    this.config = {
      maxBodyLength: Infinity,
      headers: {
        "Content-Type": "application/json",
        Authorization: this.token ? `Bearer ${this.token}` : "",
      },
    };

    if (data) {
      this.data = data;
      this.config.data = data;
    }
  }

  find = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/find/${this.data.term}`;
    this.config.method = "get";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Pesquisa de fornecedores",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };
}

export default ApiFornecedores;
